import React, { useState, useEffect } from 'react';
import CheckBox from '../Experiment/ImagingSchedule/CheckBox';
import RMSelect from './RMSelect';
import RMTable from './RMTable';
import { getImagingScheduleOptions } from 'components/customComponents/Experiment/ImagingSchedule/ImagingScheduleCommon';

let imagingScheduleOptions = [];
const headersContent = [];
let selectedScheduleId = 0;

function RMImagingSchedule({ imgSchedules, selImagingSchedule, setSelImagingSchedule }) {
  const [schedulesOptions, setSchedulesOptions] = useState([]);
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [header, setHeaders] = useState(null);
  const [scheduleEntries, setScheduleEntries] = useState(null);
  function setTableColumns(headerNames) {
    const headers = columnsHtml(headerNames);
    setColumns(headers);
  }

  useEffect(() => {
    async function fetchData() {
      if (imgSchedules === null) {
        return;
      }
      setSchedulesOptions(imgSchedules.imagingSchedules);
      const headerNames = imgSchedules.headers;
      setHeaders(headerNames);
      const enteries = imgSchedules.imagingScheduleEntries;
      setScheduleEntries(enteries);
      imagingScheduleOptions = [...imgSchedules.imagingScheduleEntries];
      const data = getImagingScheduleOptions(
        imgSchedules.imagingScheduleEntries,
        selImagingSchedule ?? imgSchedules.imagingSchedules[0]?.id ?? 1,
      );
      setTableColumns(headerNames);
      setData(
        optionsForScheduling(data, headerNames, imgSchedules.imagingScheduleEntries),
      );
    }
    fetchData();
  }, [imgSchedules]);
  function getUniqueSchedules(schedules) {
    const uniqueSchedules = [];
    schedules.map((schedule) => {
      const alreadyExist = uniqueSchedules.find(
        (s) =>
          s.days === schedule.days &&
          s.hours === schedule.hours &&
          s.entryId === schedule.entryId,
      );
      if (!alreadyExist) {
        uniqueSchedules.push(schedule);
      }
    });
    return uniqueSchedules;
  }
  function optionsForScheduling(tableData, names, imgScheduleOptions) {
    const htmlDataforTable = [];
    const uniqueData = getUniqueSchedules(tableData).sort(function (x, y) {
      const n = x.days - y.days;
      if (n !== 0) {
        return n;
      }
      return x.hours - y.hours;
    });
    for (let i = 0; i < uniqueData.length; i++) {
      const entry = {
        day: uniqueData[i].days,
        hour: uniqueData[i].hours,
        dayNum: uniqueData[i].days,
        hourNum: uniqueData[i].hours,
        entryId: uniqueData[i].entryId,
      };
      for (let j = 0; j < names.length; j++) {
        const isfound = tableData.find(
          (s) =>
            s.days === uniqueData[i].days &&
            s.hours === uniqueData[i].hours &&
            names[j] === s.cpName &&
            s.isSelected &&
            s.entryId === uniqueData[i].entryId,
        );
        const name = names[j];
        let acc = '';
        name.split(' ').map((n) => (acc += n));
        if (isfound) {
          entry[acc] = (
            <CheckBox
              isChecked={true}
              row={uniqueData[i]}
              acc={names}
              imgScheduleOptions={imgScheduleOptions}
              cpName={name}
              onChange={() => null}
            />
          );
        } else {
          entry[acc] = (
            <CheckBox
              isChecked={false}
              row={uniqueData[i]}
              acc={names}
              imgScheduleOptions={imgScheduleOptions}
              cpName={name}
            />
          );
        }
      }
      htmlDataforTable.push(entry);
    }
    return htmlDataforTable;
  }
  function isFindInEnteries(entry, cpName) {
    let isFind = false;
    for (let i = 0; i < imagingScheduleOptions.length; i++) {
      const curEntry = imagingScheduleOptions[i];
      if (
        curEntry.id == entry.id &&
        curEntry.days == entry.days &&
        curEntry.hours == entry.hours &&
        curEntry.cpName == cpName
      ) {
        isFind = true;
        break;
      }
    }
    return isFind;
  }

  function columnsHtml(names) {
    const cols = [];
    let isAllSelected = true;
    let isEntryExistAgainstSchedule = false;
    for (let i = 0; i < imagingScheduleOptions.length; i++) {
      for (let j = 0; j < headersContent.length; j++) {
        if (imagingScheduleOptions[i].id === selectedScheduleId) {
          const isFind = isFindInEnteries(imagingScheduleOptions[i], headersContent[j]);
          if (!isFind || !imagingScheduleOptions[i].isSelected) {
            isAllSelected = false;
            break;
          }
          isEntryExistAgainstSchedule = true;
        }
      }
      if (!isAllSelected) {
        break;
      }
    }
    if (!isEntryExistAgainstSchedule) {
      isAllSelected = false;
    }
    cols.push(
      {
        Header: 'Day',
        accessor: 'day',
      },
      {
        Header: 'Hour',
        accessor: 'hour',
      },
    );
    for (let i = 0; i < names.length; i++) {
      const name = names[i];
      let acc = '';
      name.split(' ').map((n) => (acc += n));
      let isColSelected = true;
      isEntryExistAgainstSchedule = false;
      for (let i = 0; i < imagingScheduleOptions.length; i++) {
        if (imagingScheduleOptions[i].id === selectedScheduleId) {
          const isFind = isFindInEnteries(imagingScheduleOptions[i], name);
          if (
            !isFind ||
            (!imagingScheduleOptions[i].isSelected &&
              imagingScheduleOptions[i].cpName === name)
          ) {
            isColSelected = false;
            break;
          }
          isEntryExistAgainstSchedule = true;
        }
        if (!isColSelected) {
          break;
        }
      }
      if (!isEntryExistAgainstSchedule) {
        isColSelected = false;
      }
      cols.push({
        Header: <div className="height35">{name}</div>,
        accessor: acc,
      });
    }
    return cols;
  }

  function onImagingScheduleChange(e) {
    selectedScheduleId = parseInt(e.target.value);
    const data = getImagingScheduleOptions(scheduleEntries, selectedScheduleId);

    setData(optionsForScheduling(data, header, scheduleEntries));
    setSelImagingSchedule(selectedScheduleId);
  }

  return (
    <>
      <div
        id="controls-rmimagingschedule-container"
        data-testid="controls-rmimagingschedule-container"
        className="flex w-100 space-between"
      >
        <label
          id="controls-rmimagingschedule-header"
          data-testid="controls-rmimagingschedule-header"
          style={{ width: '30%' }}
        >
          Scheduling
        </label>
        <RMSelect
          style={{ width: '40%' }}
          options={schedulesOptions}
          placeholder={null}
          onChange={onImagingScheduleChange}
          selectedValue={selImagingSchedule}
        />
      </div>

      <div
        id="controls-rmimagingschedule-table-wrapper"
        data-testid="controls-rmimagingschedule-table-wrapper"
        style={{ display: 'flex', height: '89%', marginTop: '10px' }}
      >
        <RMTable tableClass="w-full bg-blue-200" columns={columns} data={data} />
      </div>
    </>
  );
}

export default RMImagingSchedule;
